import { Button } from '@liza/ui/components/ui/button';
import { cn } from '@liza/ui/utils';
import type { LucideIcon } from 'lucide-react';

type Props = {
  label: string;
  icon: LucideIcon;
  active: boolean;
  onClick: () => void;
};

export const ResourceNavButton = ({ label, icon: Icon, active, onClick }: Props): React.ReactElement => (
  <Button
    variant="ghost"
    size="sm"
    onClick={onClick}
    aria-current={active ? 'page' : undefined}
    className={cn(
      'w-full justify-start gap-3 font-normal',
      active ? 'bg-accent text-accent-foreground' : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
    )}
  >
    <Icon className={cn('size-4', active ? 'text-accent-foreground' : 'text-muted-foreground/70')} />
    <span>{label}</span>
  </Button>
);
